import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert, Spinner, InputGroup } from "react-bootstrap";
import bg2 from "../assets/img/image.jpg";
import logo from "../assets/img/logo.jpeg";

const styles = `
  .password-input-wrapper {
    position: relative;
  }
  .password-input {
    padding-right: 45px !important;
  }
  .password-toggle-btn {
    position: absolute; 
    right: 0;
    top: 0;
    height: 100%;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #6c757d;
    cursor: pointer;
    z-index: 5;
  }
  .password-toggle-btn:hover {
    color: #007bff;
  }
  .btn-sign {
    background: linear-gradient(135deg, #4361ee, #3a56d4);
    border: none;
    padding: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  .btn-sign:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(67, 97, 238, 0.3);
  }
  .code-input {
    letter-spacing: 8px;
    font-size: 2rem;
    font-weight: 700;
    text-align: center;
    padding: 10px;
  }
  .two-factor-step {
    animation: fadeIn 0.5s ease;
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export default function Signin2() {
  const navigate = useNavigate();
  
  // États pour le formulaire principal
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  // États pour la 2FA
  const [step, setStep] = useState('login'); // 'login', 'verify'
  const [userId, setUserId] = useState(null);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [rememberDevice, setRememberDevice] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const API_URL = 'https://sawd.julesferry-ga.com/api/login.php';

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
   
      if (!response.ok) {
        setError(data.message || "Email ou mot de passe incorrect");
        setLoading(false);
        return;
      }

      if (data.success) {
        // Vérifier si la 2FA est activée pour cet utilisateur
        if (data.requires_2fa) {
          // Stocker l'ID utilisateur pour la vérification
          setUserId(data.user_id);
          setStep('verify');
          setLoading(false);
        } else {
          // Pas de 2FA, connexion directe
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          navigate("/dashboard/finance");
        }
      } else {
        setError(data.message || "Email ou mot de passe incorrect");
      }
    } catch (err) {
      console.error("Erreur de connexion:", err);
      setError(`Erreur de connexion au serveur: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify2FA = async (e) => {
    e.preventDefault();
    
    if (!twoFactorCode || twoFactorCode.length !== 6) {
      setError("Veuillez saisir le code à 6 chiffres");
      return;
    }

    setVerifying(true);
    setError("");

    try {
      const API_URL = 'https://sawd.julesferry-ga.com/api/verify_2fa.php';

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ 
          user_id: userId, 
          code: twoFactorCode,
          remember: rememberDevice 
        }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/dashboard/finance");
      } else {
        setError(data.message || "Code incorrect");
        setTwoFactorCode("");
      }
    } catch (err) {
      console.error("Erreur vérification 2FA:", err);
      setError(`Erreur de vérification: ${err.message}`);
    } finally {
      setVerifying(false);
    }
  };

  const handleResendCode = async () => {
    setVerifying(true);
    setError("");

    try {
      const API_URL = 'https://sawd.julesferry-ga.com/api/resend_2fa.php';

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();

      if (data.success) {
        setError(""); // Effacer l'erreur
        alert("Un nouveau code vous a été envoyé");
      } else {
        setError(data.message || "Erreur lors de l'envoi du code");
      }
    } catch (err) {
      console.error("Erreur renvoi code:", err);
      setError(`Erreur de connexion: ${err.message}`);
    } finally {
      setVerifying(false);
    }
  };

  const handleBackToLogin = () => {
    setStep('login');
    setTwoFactorCode("");
    setError("");
  };

  // Rendu conditionnel selon l'étape
  const renderContent = () => {
    if (step === 'verify') {
      return (
        <div className="two-factor-step">
          <div className="text-center mb-4">
            <div 
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #4361ee20, #80b3ff20)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 15px'
              }}
            >
              <i className="ri-shield-keyhole-line text-primary" style={{ fontSize: '40px' }}></i>
            </div>
            <h4 className="fw-bold">Authentification à deux facteurs</h4>
            <p className="text-muted mb-0">
              Saisissez le code à 6 chiffres envoyé à votre application d'authentification
            </p>
          </div>

          <Form onSubmit={handleVerify2FA}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Code de vérification</Form.Label>
              <Form.Control
                type="text"
                value={twoFactorCode}
                onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                required
                size="lg"
                className="code-input"
                maxLength="6"
                disabled={verifying}
              />
              <Form.Text className="text-muted">
                Entrez les 6 chiffres affichés dans votre application
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Check
                type="checkbox"
                id="remember-device"
                label="Mémoriser cet appareil pendant 30 jours"
                checked={rememberDevice}
                onChange={(e) => setRememberDevice(e.target.checked)}
                disabled={verifying}
              />
            </Form.Group>

            <Button 
              type="submit" 
              className="btn-sign w-100 mb-3"
              disabled={verifying || twoFactorCode.length !== 6}
              size="lg"
            >
              {verifying ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Vérification...
                </>
              ) : (
                "Vérifier"
              )}
            </Button>

            <div className="d-flex justify-content-between align-items-center">
              <Button 
                variant="link" 
                className="text-decoration-none p-0"
                onClick={handleResendCode}
                disabled={verifying}
              >
                <i className="ri-mail-send-line me-1"></i>
                Renvoyer le code
              </Button>
              
              <Button 
                variant="link" 
                className="text-decoration-none p-0 text-muted"
                onClick={handleBackToLogin}
                disabled={verifying}
              >
                <i className="ri-arrow-left-line me-1"></i>
                Retour
              </Button>
            </div>
          </Form>
        </div>
      );
    }

    // Étape login (par défaut)
    return (
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4">
          <Form.Label className="fw-semibold">Adresse Email</Form.Label>
          <Form.Control 
            type="email" 
            placeholder="exemple@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            required
            size="lg"
          />
        </Form.Group>
        
        <Form.Group className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Form.Label className="fw-semibold mb-0">Mot de passe</Form.Label>
            <Link to="/forgot-password" className="text-primary small">
              Mot de passe oublié?
            </Link>
          </div>
          <div className="password-input-wrapper">
            <Form.Control 
              type={showPassword ? "text" : "password"}
              placeholder="Entrez votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
              className="password-input"
              size="lg"
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={showPassword ? "ri-eye-off-line fs-5" : "ri-eye-line fs-5"}></i>
            </button>
          </div>
        </Form.Group>
        
        <Button 
          type="submit" 
          className="btn-sign w-100 mt-3"
          disabled={loading}
          size="lg"
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Connexion en cours...
            </>
          ) : (
            "Se connecter"
          )}
        </Button>
      </Form>
    );
  };

  return (
    <>
      <style>{styles}</style>
      
      <div className="page-sign d-block py-0">
        <Row className="g-0">
          <Col md="7" lg="5" xl="4" className="col-wrapper">
            <Card className="card-sign border-0 shadow-lg">
              <Card.Header className="bg-white border-0 pt-4" align="center">
                <p>
                  <img 
                    src={logo} 
                    style={{ 
                      height: "80px", 
                      width: "80px",
                      borderRadius: "50%", 
                      border: "3px solid #4361ee",
                      objectFit: "cover"
                    }} 
                    alt="Logo" 
                  />
                </p>
                <Card.Title className="h3 mb-2">
                  {step === 'verify' ? 'Vérification 2FA' : 'Authentification'}
                </Card.Title>
                <Card.Text className="text-muted">
                  {step === 'verify' 
                    ? 'Sécurisez votre compte avec le code à 6 chiffres'
                    : 'Bienvenue! Veuillez vous connecter pour continuer.'
                  }
                </Card.Text>
              </Card.Header>
              <Card.Body className="px-4 pb-4">
                {error && (
                  <Alert variant="danger" onClose={() => setError("")} dismissible className="mb-4">
                    <i className="ri-error-warning-line me-2"></i>
                    {error}
                  </Alert>
                )}
                
                {renderContent()}
              </Card.Body>
            </Card>
          </Col>
          
          <Col className="d-none d-lg-block">
            <img 
              src={bg2} 
              className="auth-img vh-100 object-fit-cover w-100" 
              alt="Authentification" 
              style={{ objectFit: 'cover' }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}